import Commons from "oc-commons/Commons.js";

const connectorCache = Commons.cache((name, figure, strengthFactor)=>new ConnectorType(name, figure, strengthFactor));

/**
 * Der Typ eines Connectors, also in erster Linie die Figure: Anchor, Hook, Eyelet, Magnet und ein Typ-Name.
 */
export default class ConnectorType {

    /** @type {string} */
    name;
    /** @type {string} */
    figure;
    /** @type {*} */
    color;
    /** @type {number} */
    strengthFactor;

    static Figures = {
        // Anchor geht eine Verbindung mit dem Boden ein (y=0)
        Anchor: 'Anchor',
        // Hook geht eine Verbindung mit einem Eyelet gleichen Typ-Namens ein
        Hook: 'Hook',
        // Eyelet geht eine Verbindung mit einem Hook gleichen Typ-Namens ein
        Eyelet: 'Eyelet',
        // Magnet geht eine Verbindung mit einem Magnet gleichen Typ-Namens ein
        Magnet: 'Magnet',
    };

    /**
     * Ermöglicht optional Kurzschreibweisen für ConnectorTypes als Array
     * Array: [name, figure, strengthFactor]
     * @param {(ConnectorType|Array<string>)} type
     */
    static ensureType(type) {
        return _.isArray(type) ? connectorCache(...type) : type;
    }

    /**
     * Creates an instance of ConnectorType.
     * @param {string} name
     * @param {string} figure
     * @param {number} [strengthFactor=1]
     * @param {string} [color='#ffffff']
     */
    constructor(name, figure, strengthFactor = 1, color = '#ffffff') {
        this.name = name;
        this.figure = figure;
        this.color = color;
        this.strengthFactor = strengthFactor;
    }

}
